import SectionContainer from "@/features/LandingPages/components/SectionContainer";
import { AI_TOOLS } from "@knowt/syncing/constants/ai-tools";
import shuffle from "lodash-es/shuffle";
import TeacherAIToolCard from "./TeacherAIToolCard";
import RepeatAutoFillGrid from "@/components/styled/div/RepeatAutoFillGrid";

const OtherTools = ({ tool }: { tool?: string }) => {
    const allAiTools = Object.values(AI_TOOLS);

    const randomTools = shuffle(allAiTools)
        .filter(aiTool => aiTool.title !== tool)
        .slice(0, 8);

    return (
        <SectionContainer
            title="Check out our other tools"
            subtitle="Make teaching 50% faster by using our thoughtfully crafted teacher tools."
            headerStyle={{
                maxWidth: "73rem",
            }}>
            <RepeatAutoFillGrid itemMinWidth="23rem" style={{ gap: "1.2rem" }}>
                {randomTools.map(tool => (
                    <TeacherAIToolCard key={tool.title} tool={tool} />
                ))}
            </RepeatAutoFillGrid>
        </SectionContainer>
    );
};

export default OtherTools;
